import request from '../request'

export const skillsApi = {
  // 获取技能列表
  getList() {
    return request.get('/v1/skill/list')
  },

  // 获取技能详情
  getDetail(skillId) {
    return request.get(`/v1/skill/${skillId}`)
  },

  // 获取技能更新日志
  getChangelog(skillId) {
    return request.get(`/v1/skill/${skillId}/changelog`)
  },

  // 获取技能文件列表
  getFiles(skillId) {
    return request.get(`/v1/skill/${skillId}/files`)
  }
}
